<script>
export default {
	props: ["project"],
};
</script>

<template>
	<a
		:href="project.link"
		target="_blank"
		class="group block relative bg-white dark:bg-black rounded-md transition-colors duration-300 border border-gray-200 dark:border-gray-800 hover:border-gray-400 dark:hover:border-gray-500 p-5 sm:p-6"
	>
	<!-- Card content -->
		<div class="relative h-full flex flex-col">
			<!-- Header with icon -->
			<div class="flex items-start justify-between mb-2">
				<div class="flex items-center space-x-2">
					<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-500 dark:text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
					</svg>
					<!-- Title -->
					<h3 class="font-sans font-semibold text-xl text-blue-600 dark:text-blue-400 hover:underline">
						{{ project.title }}
					</h3>
				</div>
			</div>

			<!-- Description -->
			<p class="font-sans text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-4 flex-grow line-clamp-3 text-justify ml-7">
				{{ project.description || 'No description provided.' }}
			</p>

			<!-- Tags (Languages) -->
			<div class="flex flex-wrap items-center gap-3 mt-auto ml-7">
				<span
					v-for="tag in project.tags"
					:key="tag"
					class="flex items-center text-xs font-mono text-gray-600 dark:text-gray-400"
				>
					<span class="w-2.5 h-2.5 rounded-full bg-gray-400 dark:bg-gray-600 mr-1.5"></span>
					{{ tag }}
				</span>
			</div>
		</div>
	</a>
</template>

<style scoped>
/* Limit description to 3 lines */
.line-clamp-3 {
	display: -webkit-box;
	-webkit-line-clamp: 3;
	line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
</style>
